export const iconFontAwesomeCharityHandshakeAngle = (
	<i className="fa-solid fa-handshake-angle"></i>
);
